import composeRequest, {
  authHeaders,
  hostHeaders,
  method,
  query,
  urlTagged,
} from 'api/helpers';

export function newSearchRequest({
  ampUrl,
  host,
  params,
  profileId,
  sessionId,
}: {
  ampUrl: string;
  host: string;
  params: any;
  profileId: string | number;
  sessionId: string;
}) {
  return composeRequest(
    method('get'),
    urlTagged`${{ ampUrl }}/api/v3/search/combined`,
    query({ ...params }),
    authHeaders(profileId, sessionId),
    hostHeaders(host),
  )();
}
